"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteMaxAELaengePatcher = void 0;
const KetteList_1 = require("./KetteList");
class KetteMaxAELaengePatcher {
    static process(ketteList, aeList) {
        const ketteArray = ketteList.toArray();
        const ketten = new Map();
        const aeArray = aeList.toArray();
        for (const kette of ketteArray) {
            ketten.set(kette.id, kette);
        }
        for (const ae of aeArray) {
            if (ae.ketteRef) {
                for (const ketteRefItem of ae.ketteRef) {
                    const kette = ketten.get(ketteRefItem);
                    if (kette && (!kette.maxAELaenge || ae.laenge.mm > kette.maxAELaenge.mm)) {
                        kette.maxAELaenge = ae.laenge;
                    }
                }
            }
        }
        return KetteList_1.KetteList.fromArray(Array.from(ketten.values()));
    }
}
exports.KetteMaxAELaengePatcher = KetteMaxAELaengePatcher;
//# sourceMappingURL=KetteMaxAELaengePatcher.js.map